import { Component, forwardRef, Input, OnInit, Pipe, PipeTransform } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../base_control_value_accessor/base';

@Component({
  selector: 'logzy-view-data-field',
  templateUrl: './view-data-field.component.html',
  styleUrls: ['../form-field.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ViewDataFieldComponent),
    }
  ]
})
export class ViewDataFieldComponent extends BaseControlValueAccessor implements OnInit {

  @Input()
  list: any = [];

  @Input()
  displayField: string;
  @Input()
  displayField1: string;
  @Input()
  displayField2: string;
  @Input()
  displayField3: string;
  @Input()
  displayField4: string;
  @Input()
  space1: string;
  @Input()
  space2: string;
  @Input()
  space3: string;
  @Input()
  space4: string;
  @Input()
  date: Date;
  @Input()
  showPurpose: boolean = false;

  @Input()
  lead: boolean = false;

  viewmore: boolean = false

  getDisplay() {
    if (this.data == null || this.data == undefined) {
      return '-';
    } else {
      return this.data
    }
  }
  view_more() {
    this.viewmore = !this.viewmore;
  }

  constructor() {
    super();
  }

  ngOnInit(): void {
  }

}
